export default __webpack_public_path__ + "assets/FLG_letter.56b68934.pdf";